<template>
    <v-container class="max-container">
        <!--NOTIFICATION-->
            <v-row class="notification__row">
                <!--NOTIFICATION-EVENT-->
                    <v-col :cols=" hasColdynamic ? '6' : '4' " class="notification__row__colheader">
                        <v-row class="notification__row__header">
                            <v-col class="notification__row__header__coltitle no-pd-l" cols="12">
                                <v-skeleton-loader class="notification__row__header__coltitle__title" type="image"/>
                            </v-col>
                            <v-col class="notification__row__header__colsubtitle no-pd-l" cols="6">
                                <v-skeleton-loader class="notification__row__header__colsubtitle__subtitle" type="image"/>
                            </v-col>
                        </v-row>
                    </v-col>
                <!--END-NOTIFICATION-EVENT-->
                <!--DESCRIPTION-EVENT-->
                    <v-col class="notification__row__colbody no-pd-t no-pd-l" :cols=" hasColdynamic ? '12' : '8' ">
                        <v-skeleton-loader type="list-item-three-line"/>
                    </v-col>
                <!--END-DESCRIPTION-EVENT-->
            </v-row>
        <!--END-NOTIFICATION-->
    </v-container>
</template>

<script>
export default {
    name: 'notificationLoader',
    data: () => ({
        hasColdynamic: false
    }),
    created() {
        window.addEventListener("resize", this.compareWidth);
    },
    methods: {
        compareWidth() {
            ( window.innerWidth < 960)? this.hasColdynamic = true : this.hasColdynamic = false;           
        },
    }
}
</script>

<style scoped>
    .notification__row {
        display: flex;
        flex: auto !important;
        flex-direction: row;
    }
    .notification__row__header {
        display: flex;
        flex: auto !important;
        flex-direction: column;
    }
    .notification__row__header__coltitle__title {
        height: 22px;
        border-radius: 10px;
    }
    .notification__row__header__colsubtitle__subtitle {
        height: 16px;
        border-radius: 6px;
    }
    /*RESPONSIVITY*/
        @media(max-width: 959px) {
            .notification__row {
                flex-direction: column;
            }
        }
    /*END-RESPONSIVITY*/
</style>